import { snakeToCamel } from '../CaseUtils';

/**
 * Transforms a raw message object from the API into a camelCase shape.
 *
 * Confirmed API shape (GET /deliveryops/messages/threads/{driverId}):
 * {
 *   id,                          — thread row ID (used for mark-as-read)
 *   body,                        — message text (NOTE: field is "body", not "text")
 *   sent_at,                     — ISO-8601 UTC timestamp
 *   from_uid,                    — sender's user ID
 *   to_uid,                      — recipient's user ID
 *   is_read,                     — boolean
 *   read_at,                     — ISO-8601 UTC string | null
 *   delivery_method,             — "inApp" | "push"
 *   sender_role                  — "dispatcher" | "driver"
 * }
 *
 * After snakeToCamel: id, body, sentAt, fromUid, toUid, isRead, readAt,
 *                     deliveryMethod, senderRole
 */
export const MessageETL = (message) => snakeToCamel(message);

/**
 * Transforms a list of messages (a single driver's full thread).
 */
export const MessageThreadETL = (messages) => messages?.map(MessageETL) ?? [];

/**
 * Transforms a thread summary object (one row in the driver thread list).
 *
 * Confirmed API shape (GET /deliveryops/messages/threads):
 * {
 *   driver_id, driver_first_name, driver_last_name,
 *   last_message_text,           — body of the most recent message today
 *   last_message_at,             — ISO-8601 UTC timestamp
 *   unread_count                 — count of driver messages with is_read = 0
 * }
 */
export const ThreadSummaryETL = (summary) => snakeToCamel(summary);

/**
 * Transforms the list of all driver thread summaries for today.
 */
export const ThreadSummaryListETL = (list) =>
  list?.map(ThreadSummaryETL) ?? [];
